const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_AUTH_USER_POOL_ID || 'us-east-1_9EXSggCRi',
      userPoolClientId: process.env.REACT_APP_AUTH_USER_POOL_WEB_CLIENT_ID || '24ncd6fpqm4i31j38h6u2sl88h',
      loginWith: {
        // OAuth deshabilitado - solo email/contraseña
        // oauth: {
        //   domain: 'agrosuperarking-qa.auth.us-east-1.amazoncognito.com',
        //   scopes: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
        //   redirectSignIn: ['http://localhost:3000/', 'https://admin.agrosuper.mooestroportal.com/'],
        //   redirectSignOut: ['http://localhost:3000/', 'https://admin.agrosuper.mooestroportal.com/'],
        //   responseType: 'code',
        // }
      }
    }
  }
};

export default awsConfig;